import './GeneralInfoCardComponent.scss';
import LoaderComponent from "../loader/LoaderComponent";

interface MiniCardProps {
    value: number | string;
    label: string;
    icon: any;
    prefixIcon?: any;
    loading?: boolean;
}

const GeneralInfoCardComponent = (props: MiniCardProps) => {
    const {value, label, loading, prefixIcon, icon} = props;

    return (
        <div className="mini-card">
            {
                loading && <LoaderComponent/>
            }
            <div className="info-card">
                {
                    !loading && <>

                        <div className="icon-container">
                            {icon}
                        </div>
                        <div className="value">{prefixIcon ? <span className="prefix-icon">{prefixIcon}{value}</span> :
                            <span>{value}</span>}</div>
                        <div className="label">{label}</div>
                    </>
                }
            </div>
        </div>
    );
}

export default GeneralInfoCardComponent;
